import './TitleBar.css';
import * as React from 'react';

class TitleBar extends React.Component {

  render() {
    const Tag = this.props.component || "div";

    return (
        <Tag className={"title-bar " + (this.props.align ? "title-bar-" + this.props.align : "title-bar-center")} style={this.props.style} href={this.props.href} to={this.props.to}>
          {
            this.props.startIcon &&
            <div className="title-bar-start-icon">
              {this.props.startIcon}
            </div>
          }
          <div className={"title-bar-text"}>
            {this.props.children}
          </div>
          {
            this.props.endIcon &&
            <div className="title-bar-end-icon">
              {this.props.endIcon}
            </div>
          }
        </Tag>
    );
  }
}

export default TitleBar;
